import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import BTable from 'react-bootstrap/Table';
import { Button } from 'react-bootstrap'
import React, { useState, useContext } from 'react';
import PrivilegesContext from '../../../contexts/PrivilegesContext';

export default function SubCategoriesTable({ data, categoryId, setDialogData }) {
    const [newSubCategoryName, setNewSubCategoryName] = useState("");
    const { canConfigure } = useContext(PrivilegesContext);
    const { t } = useTranslation();

    const addNewItem = () => {
        if (newSubCategoryName) {
            // Use date now as a temporary Id for UI tracking. This will be cleared when we pass to backend
            setDialogData([...data, { categoryId: categoryId, name: newSubCategoryName, id: Date.now(), isNew: true }]);
            setNewSubCategoryName("");
        }
    }

    return (data &&
        <>
            <label>{t('SubCategoryTable.Title')}</label>
            <BTable responsive striped bordered hover size="sm">
                <thead>
                    <tr>
                        <th>Name</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row) => (
                        <tr key={row.id}>
                            <td>
                                <div class="input-group">
                                    <input
                                        type="text"
                                        value={row.name}
                                        class="form-control"
                                        onChange={(e) => setDialogData(data.map(sc => sc.id.toString() === row.id.toString() ? { ...sc, name: e.target.value } : sc))}
                                        disabled={!canConfigure}
                                    />
                                    <div class="input-group-append ps-1">
                                        <Button variant="danger" type="button" onClick={() => setDialogData(data.filter(sc => sc.id !== row.id))} disabled={!canConfigure}><FontAwesomeIcon icon={faTrash} /></Button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    ))}
                    <tr>
                        <td>
                            <div class="input-group">
                                <input
                                    type="text"
                                    placeholder="New Sub Category"
                                    value={newSubCategoryName}
                                    class="form-control"
                                    onChange={(e) => setNewSubCategoryName(e.target.value)}
                                    disabled={!canConfigure}
                                />
                                <div class="input-group-append ps-1">
                                    <Button variant="primary" onClick={() => addNewItem()} disabled={!canConfigure}><FontAwesomeIcon icon={faPlus} /></Button>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </BTable>
        </>
    );
}